import React, { useState, useMemo } from 'react';
import { Card, CardBody, CardHeader, Col, Row, Button } from 'reactstrap';
import CountUp from "react-countup";
import { ConfidenceLevelCharts } from './DashboardAnalyticsCharts';
const confidenceLevelData = require('./fakedata/confidence_level.json');

function ConfidenceLevelChart() {
    const [selectionData, setSelectionData] = useState(confidenceLevelData.last_month);
    const [activePeriod, setActivePeriod] = useState("last_month");

    const onChangeChartPeriod = (period) => {
        setSelectionData(confidenceLevelData[period]);
        setActivePeriod(period);
    };

    const chartSeries = [
        {
            name: 'Selection Time',
            data: Object.values(selectionData).map(item => item.count)
        },
        {
            name: 'Year',
            data: Object.values(confidenceLevelData.last_year).map((item, index) => item.count - Object.values(selectionData)[index].count)
        }
    ];

    const chartLabels = Object.keys(confidenceLevelData.last_year);

    const totalPersons = useMemo(() => {
        return Object.values(selectionData).reduce((total, item) => total + item.count, 0);
    }, [selectionData]);

    const averageConfidenceLevel = useMemo(() => {
        if (totalPersons === 0) return 0;
        const totalScore = Object.entries(selectionData).reduce((total, [key, item]) => {
            const level = parseInt(key.split('_')[1], 10); // Get the numeric value from the key
            return total + item.count * level;
        }, 0);
        return Math.round(totalScore / totalPersons);
    }, [selectionData, totalPersons]);

    const formatConfidenceLevel = (level) => {
        const parts = level.split('_');
        const start = parts[1];
        const end = parseInt(start, 10) + 10;
        return `%${start}-%${end}`;
    };

    const mostFrequentConfidenceLevel = useMemo(() => {
        let maxCount = 0;
        let maxGroup = chartLabels[0];
        Object.entries(selectionData).forEach(([group, { count }]) => {
            if (count > maxCount) {
                maxCount = count;
                maxGroup = group;
            }
        });
        return formatConfidenceLevel(maxGroup);
    }, [selectionData, chartLabels]);

    const cardStyle = {
        minHeight: '450px', // Set your desired height here
    };

    return (
        <React.Fragment>
            <Col xl={12}>
                <Card style={cardStyle}>
                    <CardHeader className="border-0 align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Confidence Level</h4>
                        <div className="d-flex gap-1">
                            <Button
                                type="button"
                                className={`btn btn-soft-secondary btn-sm ${activePeriod === "last_year" ? "active" : ""}`}
                                onClick={() => { onChangeChartPeriod("last_year"); }}
                            >
                                Year
                            </Button>
                            <Button
                                type="button"
                                className={`btn btn-soft-secondary btn-sm ${activePeriod === "last_month" ? "active" : ""}`}
                                onClick={() => { onChangeChartPeriod("last_month"); }}
                            >
                                1M
                            </Button>
                            <Button
                                type="button"
                                className={`btn btn-soft-secondary btn-sm ${activePeriod === "last_3_months" ? "active" : ""}`}
                                onClick={() => { onChangeChartPeriod("last_3_months"); }}
                            >
                                3M
                            </Button>
                            <Button
                                type="button"
                                className={`btn btn-soft-secondary btn-sm ${activePeriod === "last_6_months" ? "active" : ""}`}
                                onClick={() => { onChangeChartPeriod("last_6_months"); }}
                            >
                                6M
                            </Button>
                        </div>
                    </CardHeader>
                    <CardHeader className="p-0 border-0 bg-light-subtle">
                        <Row className="g-0 text-center">
                            <Col xs={6} sm={4}>
                                <div className="p-3 border border-dashed border-start-0">
                                    <h5 className="mb-1">
                                        <span className="counter-value" data-target="most-frequent-confidence-level">
                                            {mostFrequentConfidenceLevel}
                                        </span>
                                    </h5>
                                    <p className="text-muted mb-0">Most Frequent Confidence Level</p>
                                </div>
                            </Col>
                            <Col xs={6} sm={4}>
                                <div className="p-3 border border-dashed border-start-0">
                                    <h5 className="mb-1">
                                        <span className="counter-value" data-target="average-confidence-level">
                                            {averageConfidenceLevel}
                                        </span>
                                    </h5>
                                    <p className="text-muted mb-0">Average Confidence Level</p>
                                </div>
                            </Col>
                            <Col xs={6} sm={4}>
                                <div className="p-3 border border-dashed border-start-0 border-end-0">
                                    <h5 className="mb-1">
                                        <span className="counter-value" data-target="total-persons">
                                            <CountUp start={0} end={totalPersons} duration={3} separator="," />
                                        </span>
                                    </h5>
                                    <p className="text-muted mb-0">Total Persons</p>
                                </div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="p-0 pb-2">
                        <div>
                            <div id="audiences_metrics_charts" className="apex-charts" dir="ltr">
                                <ConfidenceLevelCharts series={chartSeries} dataColors='["--vz-primary", "--vz-gray-300"]' />
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default ConfidenceLevelChart;
